import { PROYECT } from "services/api";
import { saveAs } from 'file-saver';
import axios from "axios";
import { START_REQUEST_SEARCH, STOP_REQUEST_SEARCH, SET_SNACKBAR_SEARCH } from "redux/reducers/search/searchReducer";


export const downloadReport =  (start, end, token) => {
  const auth = { headers: { authorization: token } };
  const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/stations/expenses/report?start=${start}&end=${end}`;
  const fileName = `ReporteGastos_${start}_${end}.pdf`
  return async (dispatch) => {
    dispatch({type: START_REQUEST_SEARCH})
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth
    }
    try {
      const resp = await axios(access);
      saveAs(resp.data, fileName)
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'PDF Descargado con éxito', color: 'success' }
      })
    } catch (err) {
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: err.message ? err.message : err, color: 'danger' }
      })
    } finally {
      dispatch({type: STOP_REQUEST_SEARCH})
    }
  }
}